export default __webpack_public_path__ + "static/MineralSwimV2_BLOG_HD1_1920x1000-e1da0075453f064b573f2ac01e044c0f.jpg";